module.exports = __webpack_public_path__ + "media/images/icons/icon_badge_skp-424027fb2188904d5e8166d1fd123845.svg";